import React, { useState } from 'react';
import { Box, Fab, Badge, Tooltip, Alert, Zoom, Typography } from '@mui/material';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import Main from '../layouts/Main';
import B2BProductList from '../components/B2BProductList';
import QuoteDrawer from '../components/QuoteDrawer';
import useQuote from '../hooks/useQuote';
import { money } from '../utils/quoteMath';

const B2B = () => {
  const q = useQuote();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const hasLines = q.quote.lines.length > 0;

  return (
    <Main>
      <div className="page-header">
        <div>
          <h1 className="page-title">
            <ReceiptLongIcon sx={{ fontSize: 24, mr: 1, verticalAlign: 'middle', color: '#845adf' }} />
            B2B Quotation
          </h1>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">B2B</li>
          </ol>
        </div>
      </div>

      <Alert severity="info" sx={{ mb: 2 }}>
        Search the catalog, add products with quantities, then open the quotation panel to set the
        customer, shipping and VAT. The PDF preview updates live as you type. Export it or email it
        straight to the customer. Your draft is saved automatically.
      </Alert>

      <div className="row">
        <div className="col-12">
          <div className="card custom-card">
            <div className="card-header">
              <div className="card-title">Product catalog</div>
            </div>
            <div className="card-body">
              <B2BProductList onAdd={q.addLine} onSetQty={q.setQty} skuQty={q.skuQty} />
            </div>
          </div>
        </div>
      </div>


      {/* Floating quote button — always reachable while browsing the catalog */}
      <Zoom in={hasLines}>
        <Box sx={{ position: 'fixed', bottom: 28, right: 28, zIndex: 1200, display: 'flex', alignItems: 'center', gap: 1.5 }}>
          {/* Running total pill */}
          <Box sx={{
            backgroundColor: '#111827', color: 'white', px: 2, py: 1, borderRadius: 999,
            boxShadow: '0 6px 20px rgba(0,0,0,0.25)', display: { xs: 'none', sm: 'block' }
          }}>
            <Typography variant="caption" sx={{ opacity: 0.65, display: 'block', lineHeight: 1, fontSize: 9.5 }}>
              TOTAL (incl. VAT)
            </Typography>
            <Typography variant="body2" sx={{ fontWeight: 800, lineHeight: 1.3 }}>
              {money(q.totals.total)}
            </Typography>
          </Box>

          <Tooltip title="Open quotation" placement="left">
            <Badge
              badgeContent={q.quote.lines.length}
              sx={{ '& .MuiBadge-badge': { backgroundColor: '#f59e0b', color: 'white', fontWeight: 700 } }}
            >
              <Fab onClick={() => setDrawerOpen(true)}
                   sx={{ backgroundColor: '#845adf', color: 'white', '&:hover': { backgroundColor: '#6c48c5' } }}>
                <ReceiptLongIcon />
              </Fab>
            </Badge>
          </Tooltip>
        </Box>
      </Zoom>

      <QuoteDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        quote={q.quote}
        totals={q.totals}
        updateLine={q.updateLine}
        removeLine={q.removeLine}
        setQty={q.setQty}
        setField={q.setField}
        setCustomerField={q.setCustomerField}
        setShipping={q.setShipping}
        clearLines={q.clearLines}
        resetQuote={() => { q.resetQuote(); setDrawerOpen(false); }}
      />
    </Main>
  );
};

export default B2B;
